module.exports = __webpack_public_path__ + "img/logo-large.a355c2dd.png";